module.exports = __webpack_public_path__ + "static/media/jane-philips.869a39b1.jpeg";